import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const Authority = () => {
  const { currentTheme } = useTheme();
  
  return (
    <section className={`py-16 px-6 ${currentTheme.colors.background} border-b border-gray-200`}>
      <div className="max-w-6xl mx-auto text-center">
        <motion.p 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-gray-600 text-lg mb-8"
        >
          Helping Singers Become Original Artists —<br />
          From humming their melody to launching their first original song (and earning from it)

        </motion.p>
        
        <div className="grid md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-center gap-3"
          >
            <span className="text-3xl">🎵</span>
            <span className="text-gray-800 font-semibold">Singer • Composer • Producer • Mentor</span>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="flex items-center justify-center gap-3"
          >
            <span className="text-3xl">🎧</span>
            <span className="text-gray-800 font-semibold">Founder – Indie Music Creators</span>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex items-center justify-center gap-3"
          >
            <span className="text-3xl">🚀</span>
            <span className="text-gray-800 font-semibold">90-Day Song Creation Framework</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Authority;
